import "./polyfills"; // 👈 must be the first import

import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import { createRoot } from "react-dom/client";
import { StyledEngineProvider } from "@mui/material/styles";
import App from "./app/App";
import { configureApplication } from "./app/app.service";
import "./resources/styles/index.scss";

// configureApplication()
//   .then(() => {
//     try {
//       ReactDOM.render(<App />, document.getElementById("root"));
//     } catch (error) {
//       console.logExternally("Global error captured", { error });
//     }
//   })
//   .catch((err) => {});

configureApplication()
  .then(() => {
    try {
      const container = document.getElementById("root");
      const root = createRoot(container); // 👈 new API
        root.render(
          <StyledEngineProvider injectFirst>
            <App />
          </StyledEngineProvider>
        );
    } catch (error) {
      console.logExternally("Global error captured", { error });
    }
  })
  .catch((err) => {
    console.error("Application configuration failed", err);
  });
